import { useState } from 'react';
import { Outlet } from "react-router-dom";
import StudentSidebar from "./StudentSidebar";
import Header from "../../components/header";
const StudentLayout = () => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false);
  };

  return (
     <div className="relative flex min-h-screen flex-col bg-[#f8fafc] font-[Inter,-apple-system,BlinkMacSystemFont,sans-serif]">
      <Header  />
{/* <button className="mobile-menu-btn" onClick={toggleMobileSidebar}>
          <FiMenu />
        </button> */}
       <div className="flex flex-1 max-md:flex-col">
        <StudentSidebar 
           isCollapsed={isCollapsed}
           setIsCollapsed={setIsCollapsed}
           isMobileOpen={isMobileSidebarOpen}
           onMobileClose={closeMobileSidebar}
        />

        <div
  className={`
    flex-1
    bg-[#F9F7F4]
    min-h-[calc(100vh-70px)]
    transition-all duration-300 ease-in-out
    ${isCollapsed ? "ml-0 md:ml-20" : "ml-0 md:ml-[280px]"}  
  `}
>
          <Outlet /> 
        </div>
      </div>
    </div>
  );
};

export default StudentLayout;